



























import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import TermsAndConditionsMixin from "@/components/app/global/termsAndConditions/termsAndConditionsMixin";

@Component
export default class TermsAndConditionsModal extends Mixins(
  TermsAndConditionsMixin
) {
  // Props

  @Prop({ default: true })
  public allowCopy!: boolean;

  @Prop({ default: true })
  public useTranslated!: boolean;

  @Prop({ default: "_action.close" })
  public cancelText!: string;

  // Computed

  public get terms() {
    if (this.useTranslated) return this.tAndC.terms?.terms_translated;
    return this.tAndC.terms?.terms;
  }
}
